// extracted by mini-css-extract-plugin
module.exports = {"MoreMenuBtnContainer":"Profile_MoreMenuBtnContainer__vc-8_","MoreMenuBtn":"Profile_MoreMenuBtn__20atS","userName":"Profile_userName__dTjCp","menuIcon":"Profile_menuIcon__lnPV6"};